import React, { useState, useCallback } from 'react';
import { Menu, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import BuyerCopilotMoreActionsButton from '../../../BuyerCopilot/BuyerCopilotMoreActionsButton';
import ActionsMenuItems from './ActionsMenuItems';

type Props = {
  onDeleteChatHistory: () => void;
  isExpanded: boolean;
  onExpandToggle: () => void;
};

const useStyles = makeStyles((theme: Theme) => ({
  menu: {
    marginTop: `-${theme.spacing(1)}`,
    zIndex: 2147483647,
  },
  menuRoot: {
    zIndex: 2147483647,
  },
}));

const ActionsMenu: React.FC<Props> = (props: Props): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const classes = useStyles();
  const { onDeleteChatHistory, onExpandToggle } = props;

  const onOpenMenu = useCallback((e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  }, []);

  const onCloseMenu = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const deleteChatHistory = useCallback(() => {
    onDeleteChatHistory();
    onCloseMenu();
  }, [onDeleteChatHistory, onCloseMenu]);

  const handleExpandToggle = useCallback(() => {
    onExpandToggle();
    onCloseMenu();
  }, [onExpandToggle, onCloseMenu]);

  return (
    <>
      <BuyerCopilotMoreActionsButton onClick={onOpenMenu} />
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={onCloseMenu}
        open={!!anchorEl}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            className: classes.menu,
          },
        }}
        className={classes.menuRoot}
        data-testid="menu-action-room"
      >
        <ActionsMenuItems
          onDeleteChatHistory={deleteChatHistory}
          isExpanded={props.isExpanded}
          onExpandToggle={handleExpandToggle}
        />
      </Menu>
    </>
  );
};

export default ActionsMenu;
